import globalrbac_qa from '@/env/globalrbac.qa'
import globalrbac_prod from '@/env/globalrbac.prod'
import globalrbac_dev from '@/env/globalrbac.dev'
import playerrating_qa_rbac from '@/env/playerrating-qa-rbac.solaireresort.com'
import playerrating_rbac from '@/env/playerrating-rbac.solaireresort.com'
import solaire_control_hub_rbac from '@/env/solaire-control-hub-rbac.solaireresort.com'
import defaultEnv from '@/env/default'
import type { ENVType } from '@/types/ENV'

const configMap: { [key: string]: ENVType } = {
  localhost: globalrbac_dev,
  'rbac-qa.solaireresort.com': globalrbac_qa,
  'globalrbac.solaireresort.com': globalrbac_prod,
  'playerrating-qa-rbac.solaireresort.com': playerrating_qa_rbac,
  'playerrating-rbac.solaireresort.com': playerrating_rbac,
  'solaire-control-hub-rbac.solaireresort.com': solaire_control_hub_rbac,
}

const getEnv = (hostname: string) => {
  console.log(`Fetching Variables for hostname: ${hostname}`)
  const config = configMap[hostname]

  if (!config) {
    console.log(`No configuration found for hostname: ${hostname}, reading from env:`)
    console.log(defaultEnv);

    return defaultEnv
  }

  return config
}

export default getEnv
